export default __webpack_public_path__ + "static/278362009_408432977311758_6116022313969556397_n-078f22e29eaf9558100710742e67dea4.png";